import React from "react";
import { useTranslation } from "react-i18next";
import { fieldRules } from "../methods";
import Form from "../index";
import TinyMCE from "../../TinyMCE";

export const FORM_ITEM_TINY_MCE = "form-tinyMCE";

const FormItemTinyMCE = (props) => {
  const { name, label, required, max, placeholder, rules = [], fieldProps = {}, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Form.Item
      name={name}
      label={t(label)}
      rules={fieldRules(
        {
          required: required
            ? {
                message: t("container.form_errors.required")
              }
            : false,
          max: max
            ? {
                value: max,
                message: t("container.form_errors.maxLength", { value: max })
              }
            : false
        },
        rules
      )}
      {...rest}
    >
      <TinyMCE placeholder={t(placeholder)} {...fieldProps} showMenuBar={fieldProps.showMenuBar} />
    </Form.Item>
  );
};

export default FormItemTinyMCE;
